import styled, { css } from "styled-components";
import { colorMixin } from "../../helpers";
import { TColorVariant, TSizeVariant } from "./types";

export const FeaturedIcon = styled.figure<{ $color: TColorVariant; $size: TSizeVariant }>`
    flex-shrink: 0;

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
    box-sizing: border-box;

    color: ${colorMixin("text-primary-800")};
    border: 6px solid ${colorMixin("primary-50")};
    background-color: ${colorMixin("primary-100")};
    border-radius: 100%;

    width: 32px;
    height: 32px;

    ${({ $size }) => {
        switch ($size) {
            case "xs":
                return css`
                    border-width: 2px;
                    width: 24px;
                    height: 24px;

                    svg {
                        width: 13px;
                        height: 13px;
                    }
                `;
            case "sm":
                return css`
                    border-width: 4px;
                    width: 32px;
                    height: 32px;

                    svg {
                        width: 14px;
                        height: 14px;
                    }
                `;
            case "md":
                return css`
                    border-width: 6px;
                    width: 40px;
                    height: 40px;

                    svg {
                        width: 17px;
                        height: 17px;
                    }
                `;
            case "lg":
                return css`
                    border-width: 8px;
                    width: 48px;
                    height: 48px;

                    svg {
                        width: 20px;
                        height: 20px;
                    }
                `;
            case "xl":
                return css`
                    border-width: 10px;
                    width: 56px;
                    height: 56px;

                    svg {
                        width: 24px;
                        height: 24px;
                    }
                `;
            default:
                return null;
        }
    }}

    ${({ $color }) => {
        switch ($color) {
            case "primary":
                return css`
                    color: ${colorMixin("text-primary-800")};
                    background-color: ${colorMixin("primary-100")};
                    border-color: ${colorMixin("primary-50")};
                `;
            case "success":
                return css`
                    color: ${colorMixin("success-400")};
                    background-color: ${colorMixin("success-100")};
                    border-color: ${colorMixin("success-50")};
                `;
            case "tertiary":
                return css`
                    color: ${colorMixin("tertiary-400")};
                    background-color: ${colorMixin("tertiary-100")};
                    border-color: ${colorMixin("tertiary-50")};
                `;
            case "warning":
                return css`
                    color: ${colorMixin("warning-400")};
                    background-color: ${colorMixin("warning-100")};
                    border-color: ${colorMixin("warning-50")};
                `;
            case "error":
                return css`
                    color: ${colorMixin("error-400")};
                    background-color: ${colorMixin("error-100")};
                    border-color: ${colorMixin("error-50")};
                `;
            default:
                return null;
        }
    }}
`;
